import { DetailedHTMLProps, AnchorHTMLAttributes, useMemo } from 'react';

// Styles
const styles = {
  default: {
    default: 'font-medium text-primary underline-offset-4 decoration-current',
    hover: 'hover:underline hover:text-jungle-800 hover:cursor-pointer',
    focus: 'focus:outline-2 focus:outline-black focus:outline-offset-2',
  },
  popover: {
    default: 'font-medium text-gray-900 underline decoration-dotted underline-offset-4 decoration-gray-600',
    hover: 'hover:text-black hover:cursor-pointer',
    focus: 'focus:outline-2 focus:outline-black focus:outline-offset-2',
  },
};

const sizes = {
  small: 'text-xs leading-5',
  medium: 'text-sm leading-6',
  large: 'text-base leading-7',
};

export interface TextLinkProps extends DetailedHTMLProps<AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  linkStyle?: 'default' | 'popover';
  size?: keyof typeof sizes;
}

export const TextLink = (props: TextLinkProps) => {
  const { children, size = 'small', className, tabIndex = 0, linkStyle = 'default', ...rest } = props;

  const classes = useMemo(
    () =>
      `${styles[linkStyle].default} ${sizes[size]} ${styles[linkStyle].hover} ${styles[linkStyle].focus} ${className}`,
    [className, size, linkStyle]
  );

  return (
    <a {...rest} className={classes} tabIndex={tabIndex}>
      {children}
    </a>
  );
};
